import React, {useContext} from "react";
import MaterialTable from "material-table";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { forwardRef, useState, useLayoutEffect, useRef} from 'react';

import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import ApiCall, {ExpoApiContext} from "Helper/Api.js";
import {useExpoApi} from "../../Helper/Api.js"

const tableIcons = {
Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

export default function MaterialTableDemo(props) {
  const [state, setState] = React.useState({
    columns: [],
    data: []
  });
  const [themeType,setThemeType] = useState('dark');
  const context = useContext(ExpoApiContext);
  const getApi = useExpoApi();

    const apiCallRecentExt = async ()=> {
        //dont bother with api call and rendering until divs are loaded
        if(context.divsA.length === 0 || context.divsB.length === 0 || context.divsC.length ===0
            || context.divsD.length === 0 || context.divsE.length === 0 || context.sites.length === 0) {
            return;
        }
        const divALookup = {};
        context.divsA.forEach((div) => {
            divALookup[div.id] = div.name;
        });

        const divBLookup = {};
        context.divsB.forEach((div) => {
            divBLookup[div.id] = div.name;
        });

        const divCLookup = {};
        context.divsC.forEach((div) => {
            divCLookup[div.id] = div.name;
        });

        const divDLookup = {};
        context.divsD.forEach((div) => {
            divDLookup[div.id] = div.name;
        });

        const divELookup = {};
        context.divsE.forEach((div) => {
            divELookup[div.id] = div.name;
        });

        const api = await getApi();
     api
       .getExtensionsTable()
       .then((response) => {
        setState({
          data: response.data.extensions,
          columns: [
            { title: "Id", field: "id", hidden: true},
            { title: "Extension", field: "extension" },
            { title: "UserId", field: "userId" },
            { title: "Name", field: "name" },
            { title: "Department", field: "divAId", initialEditValue: context.divsA[0].id,  lookup: divALookup},
            { title: "Branch", field: "divBId", initialEditValue: context.divsB[0].id,  lookup: divBLookup},
            { title: "Region", field: "divCId", initialEditValue: context.divsC[0].id,  lookup: divCLookup},
            { title: "Division", field: "divDId", initialEditValue: context.divsD[0].id, lookup: divDLookup},
            { title: "Organization", field: "divEId", initialEditValue: context.divsE[0].id, lookup: divELookup},
            { title: "Email", field: "email" },
            { title: "Site", field: "siteId", hidden: true},
            { title: "Note", field: "notes", hidden: true},
          ]})
        })

       .catch((err) => {console.log(err)});
    };

    React.useEffect(() => {  
      apiCallRecentExt().finally();
    }, [context.divsA, context.divsB, context.divsC, context.divsD, context.divsE, context.sites]);

  useLayoutEffect(() => {
    if(props.activeModeClass === "white-content"){  setThemeType("light")}
    else{setThemeType("dark")}
    
  }, []);
  const THEME = createMuiTheme({
    palette: {
      type: themeType,
      primary: {
        main: '#f8955e',
      },
      secondary: {
        main: '#4caf50',
      },
    },
  });
  return (
    <div>
      <MuiThemeProvider theme={THEME}>
      
          <MaterialTable
            style= {{
                backgroundColor: 'transparent',
                boxShadow: 'none',
            }}
            icons={tableIcons}
            title=""
            columns={state.columns}
            data={state.data}
            options={{
                headerStyle: {
                  backgroundColor: "rgba(0,0,0,0)",  // #6ca6c2; //67b7dc          
                  fontWeight: 'bold'
                },
                pageSizeOptions:[10,15,20],
                filtering: false
              }}
            editable={{
              onRowAdd: async (newData) => {
                try {
                  newData.siteId = context.sites[0].id || 1;
                  newData.notes = '';
                    const api = await getApi();
                  newData.id = await api.createExtension(newData);
                } catch (err) {
                    console.log(err);
                    alert(err);
                }   
                setState((prevState) => {
                  const data = [...prevState.data];
                  data.push(newData);
                  return { ...prevState, data };
                })
              },
              onRowUpdate: async (newData, oldData) => {
                if (oldData) {


                    const api = await getApi();
                    await api.updateExtension(oldData.id, newData);
                  setState((prevState) => {
                    const data = [...prevState.data];
                    data[data.indexOf(oldData)] = newData;
                    return { ...prevState, data };
                  });
                }},
              onRowDelete: async (oldData) => {


                  const api = await getApi();
                await api.deleteExtension(oldData.id);
                setState((prevState) => {
                  const data = [...prevState.data];
                  data.splice(data.indexOf(oldData), 1);
                  return { ...prevState, data };
                });
            }}} />
    
      </MuiThemeProvider>
    </div>
  );
}
